import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ParteTextoComLink, separarLinks } from '../../../core/tools/texto-com-links';

@Component({
  selector: 'app-texto-com-links',
  standalone: true,
  imports: [CommonModule],
  template: `<ng-container *ngFor="let parte of partes"><a *ngIf="parte.url; else textoSimples" [href]="parte.url" target="_blank" rel="noopener noreferrer" (click)="$event.stopPropagation()">{{ parte.texto }}</a><ng-template #textoSimples>{{ parte.texto }}</ng-template></ng-container>`,
  styles: [':host { white-space: pre-wrap; overflow-wrap: anywhere; } a { color: #0066cc; text-decoration: underline; }']
})
export class TextoComLinksComponent {
  partes: ParteTextoComLink[] = [];
  private textoAtual = '';

  @Input() set texto(valor: string | null | undefined) {
    const texto = valor || '';
    if (texto === this.textoAtual) return;
    this.textoAtual = texto;
    this.partes = separarLinks(texto);
  }
}
